import React from "react";
// import i18n from "i18n";
import styles from  "./ProductSummaryItem.module.scss";
import i18n from "i18n";


export const ProductSummaryItem = ({product, stock, units, add, subtitle}) => {
    return(
        <div className={styles["product-summary-container"]}>
            <div className={styles["product-summary-name"]}>{product.name}</div>
            <div className={styles["product-summary-brand"]}>{product.brand && product.brand.name}</div>
            <div className={styles["product-summary-code"]}>{product.sku}</div>
            {!add && <div className={styles["product-summary-units"]}>{units} {i18n.t("units")}</div>}
            {add  && <div className={`${styles['product-summary-units']} ${stock > 0 ? '' : styles["disabled"]} ${subtitle ? '' : styles["notshown"]}`}>{stock > 0 ? i18n.t("with.stock") : i18n.t("out.of.stock")} </div>}
           
        </div>
    )
}

export default ProductSummaryItem;